<div class="google_map animate__animated animate__fadeIn" #google_map></div>
